import React from 'react';
import { observer } from 'mobx-react';
import { TreeModuleStore } from '@seedlang/stores';
import CreateWithTitle from 'components/creator/create_with_title';

@observer
class TreeModuleCreate extends React.Component {

  onCreate = name => {
    TreeModuleStore.create(
      {
        data: {
          name,
          treeId: this.props.treeId,
        },
      },
      this.props.onChange,
    );
  };

  render() {
    return (
      <CreateWithTitle
        placeholder='Add a module name'
        onCreate={this.onCreate}
      />
    );
  }
}

export default TreeModuleCreate;
